import React from 'react';

import './formRow.scss';

export default function FormRow({children}: React.PropsWithChildren<unknown>) {
	return <div className="di form-row">{children}</div>;
}
